export const updateObject = (oldObjet, updatedProperties) => {
    return {
        ...oldObjet,
        ...updatedProperties
    }
}

export const convertStringToRegex = obj => {
    for (const [key, val] of Object.entries(obj)) {
        if (key === 'pattern') {
            val.value = new RegExp(val.value);
        } else if (typeof val === 'object' && val !== null) {
            convertStringToRegex(val);
        }
    }
    return obj;
}

export const arrayBufferToBase64 = (buffer) => {
    var binary = '';
    var bytes = [].slice.call(new Uint8Array(buffer));

    bytes.forEach((b) => binary += String.fromCharCode(b));

    return window.btoa(binary);
};

export const isValidTaiwanID = str => {
    const tab = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
    const A1 = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3];
    const A2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5];
    const Mx = [9, 8, 7, 6, 5, 4, 3, 2, 1, 1];

    if (str.length !== 10) return false;

    const idx = tab.indexOf(str.charAt(0));
    if (idx === -1) return false;

    let sum = A1[idx] + A2[idx] * 9;
    for (let i = 1; i < 10; i++) {
        let v = parseInt(str.charAt(i));
        if (isNaN(v)) return false;
        sum = sum + v * Mx[i];
    }
    if (sum % 10 !== 0) return false;

    return true;
}

export const isValidCompanyID = str => {
    var pattern = /^[0-9]{8}$/;
    var chk = 0;
    var pv = [1, 2, 1, 2, 1, 2, 4, 1];

    if (pattern.test(str)) {
        for (let i = 0; i < pv.length; i++) {
            var addNum = str.charAt(i) * pv[i];
            if (addNum >= 10) {
                addNum = parseInt(addNum.toString().charAt(0)) + parseInt(addNum.toString().charAt(1));
                if (addNum === 10) addNum = 0;
            }
            chk += addNum;
        }

        if (chk % 5 === 0 || (chk % 5 === 4 && str.charAt(6) === '7')) {
            return true;
        }
    }
    return false;
}

export const formatDate = date => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

export const queryParams = (params) => {
    return Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');
}

export const convertDateToString = paramObj => {
    const newDates = Object.keys(paramObj)
        .filter(k => paramObj[k] instanceof Date)
        .reduce((obj, key) => {
            const date = paramObj[key];
            const dateStr = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
                .toISOString()
                .substring(0, 10);
            obj[key] = dateStr;
            return obj;
        }, {});

        return updateObject(paramObj, newDates);
}

export const moneyCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

